<template>
  <div class="side-edit-content p-5">
    <strong class="title-main d-block mb-4">{{ $t('views.seller.integrations.config.edit.title') }}</strong>

    <!-- Exibe url -->
    <div :class="isInputError('update_url')" @click="removeError('update_url')">
      <strong class="title-medium">{{ $t('views.seller.integrations.config.save.url.title') }}</strong>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" placeholder="Informe a URL do Smart Notas" class="form-input" v-model="url" trim></b-form-input>
          </b-form-group>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_url') }}
      </span>
    </div>

    <!-- Exibe a URL webhook -->
    <div>
      <strong class="title-medium mt-4">Copie e adicione a url na configuração de webhook na Smart Notas</strong>
      <b-form-group id="fieldset-token" label-for="input-token">
          <b-form-input 
            id="update_url_webhook" 
            placeholder="URL Webhook" 
            class="form-input copy" 
            :value="url_webhook" 
            :readOnly="true"
            @click="copyValue('update_url_webhook')"
          ></b-form-input>
      </b-form-group>
      <span class="subinfo">Adicione seu token de integração na Smart Notas</span>
    </div>

  </div>
</template>

<script>

import NoteCenterIntegration from "@/services/resources/NoteCenterIntegration";
import TokenService from "@/services/resources/TokenService";

export default {
  name: "IntegrationsConfigUpdateSmartNotas",
  props: {
    opendEdit: {
      type: Boolean,
      required: true
    },
    loadingUpdate: {
      type: Boolean,
      required: true
    },
    editGroupLoad: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'SmartNotas' })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    sugestionRedirect: {
      type: Object,
      required: true,
      default: () => ({
        url: null,
        name: null,
      })
    },
    removeError: {
      type: Function,
      required: true
    },
    removeErrors: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
  },
  data: () => ({
    url: '',
    url_webhook: '',
    loadingTest: false,
  }),
  methods: {
    copyValue(type) {
      const el = document.getElementById(type);
      el.select();
      document.execCommand("copy");
      this.messageSuccess('A Url foi copiada com sucesso', 'Copiado!');
    },
    setUrl(response) {
      this.url_webhook = response.api_key;
    },
    messageSuccess(msg, title) {
      this.$bvToast.toast(msg, {
        variant: "success",
        title: title,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    async getToken() {
      await TokenService.build().get('').then(response => {
        this.setUrl(response);
      });
    },
    async showEditCallback(url) {

      this.removeErrors([
        'update_token'
      ]);

      this.$emit('update:opendEdit', true);
      this.$emit('update:editGroupLoad', true);
      this.$emit('update:loadingUpdate', false);

      await this.getToken();

      this.url = url;

      this.$emit('update:editGroupLoad', false);
    },
    updateCallbacks() {

      this.$emit('update:loadingUpdate', true);

      NoteCenterIntegration.build().post('', {
        name: 'SmartNotas',
        config_integration: {
          url: this.url
        },
        url: this.url,
        default: false
      }, { suppressErrorNotify: true })
      .then(() => {

        this.$emit('update:opendEdit', false);
        this.fetchCallbacks();

        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.success.message'), {
          title: this.$t('views.seller.integrations.config.toast.update.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
      .catch(error => {
        this.mountInputError(error.response.data, 'update_');
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.update.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
      .finally(() => {
        this.$emit('update:loadingUpdate', false);
      });
    },
  }
}

</script>